module.exports = __webpack_public_path__ + "img/activity_12.4b7a6ce3.png";